import { createContext } from 'react';

import { MyWorkItem } from '@totem/components/users/types';

interface Context {
  loading: boolean;
  data: MyWorkItem[];
  totalRecords: number;
  onRefresh: () => void;
}

export default createContext<Context>({
  loading: false,
  data: [],
  totalRecords: 0,
  onRefresh: () => {},
});
